document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {

        // 1. Hole alle .headerStart Elemente
        let headerVideos = document.querySelectorAll('.headerStart');

        headerVideos.forEach(function(element) {
            let video = element.querySelector("video");
            let src = element.querySelector("source");

            let desktopSrc = src.getAttribute("src");

            // 2. MediaQueryWatcher für verschiedene Größen
            addMediaQueryWatcher("(min-width: 1281px) and (max-width: 1920px)", (matches) => {
                if (matches) {
                    if (src.dataset.hasOwnProperty('large')) {
                        src.setAttribute("src", src.getAttribute('data-large'));
                        video.load();
                        video.play(); // Safari fix
                    } else if(src.getAttribute("src") != desktopSrc) {
                        src.setAttribute("src", desktopSrc);
                        video.load();
                        video.play();
                    }
                }
            });

            addMediaQueryWatcher("(min-width: 721px) and (max-width: 1280px)", (matches) => {
                if (matches) {
                    if (src.dataset.hasOwnProperty('medium')) {
                        src.setAttribute("src", src.getAttribute('data-medium'));
                        video.load();
                        video.play();
                    } else if(src.getAttribute("src") != desktopSrc) {
                        src.setAttribute("src", desktopSrc);
                        video.load();
                        video.play();
                    }
                }
            });

            addMediaQueryWatcher("(max-width: 720px)", (matches) => {
                if (matches) {
                    if (src.dataset.hasOwnProperty('small')) {
                        src.setAttribute("src", src.getAttribute('data-small'));
                        video.load();
                        video.play();
                    } else if(src.getAttribute("src") != desktopSrc) {
                        src.setAttribute("src", desktopSrc);
                        video.load();
                        video.play();
                    }
                }
            });



        });

        const elements = document.querySelectorAll('.headerStart');

        elements.forEach(function(element) {
            let headerSlider = new Swiper(element.querySelector(".swiper"), {
                watchOverflow: true,
                preloadImages: false,
                loop: true,
                lazy: {
                    checkInView: true,
                    loadPrevNext: true,
                    enabled: true
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                spaceBetween: 0,

                pagination: {
                    el: ".swiper-pagination",
                    type: "progressbar"
                },

                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                }
            });
        });

    });
});
